import { all } from "redux-saga/effects";
import fetchInviteTeams from "./fetchInviteTeams";
import fetchMemberTeams from "./fetchMemberTeams";
import createTeam from "./createTeam";
import fetchTeam from "./fetchTeam";
import fetchTeamMembers from "./fetchTeamMembers";
import createTeamInvite from "./createTeamInvite";
import fetchTeamInvitees from "./fetchTeamInvitees";
import removeSelfFromTeam from "./removeSelfFromTeam";
import acceptTeamInvite from "./acceptTeamInvite";
import deleteTeamInvite from "./deleteTeamInvite";
import deleteTeamMember from "./deleteTeamMember";
import updateTeam from "./updateTeam";

export default function* rootSaga(): Generator {
    yield all([
        fetchInviteTeams(),
        fetchMemberTeams(),
        createTeam(),
        fetchTeam(),
        fetchTeamMembers(),
        createTeamInvite(),
        fetchTeamInvitees(),
        removeSelfFromTeam(),
        acceptTeamInvite(),
        deleteTeamInvite(),
        deleteTeamMember(),
        updateTeam(),
    ]);
}
